<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  <ng-container notifications>
    @if (this.$isDisabled()) {
      <unity-banner-alert-shared icon="infoSolidIcon">
        <div>This Community is in a 'Disabled' state, it cannot be used elsewhere in the application.</div>
      </unity-banner-alert-shared>
    }
  </ng-container>

  <ng-container actions>
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
  </ng-container>

  @let formGroup = $formGroup();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      <unity-textbox-control displayName="Name" description="Enter the name of the city or town." [control]="formGroup.controls.name" />
      <unity-textbox-control
        displayName="Area"
        description="Specify the area in which this community is located."
        [control]="formGroup.controls.area_name" />
    </unity-form-layout>
  </unity-panel-manage-shared>
</unity-page-container>
